var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("auea534", "单位创建"),
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.createUnitModal,
      callback: function ($$v) {
        _vm.createUnitModal = $$v;
      },
      expression: "createUnitModal"
    }
  }, [_c('pro-form', {
    ref: "proForm",
    attrs: {
      "label-position": "right",
      "columns": _vm.columns
    },
    model: {
      value: _vm.data,
      callback: function ($$v) {
        _vm.data = $$v;
      },
      expression: "data"
    }
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };